import { isProduction, isStaging } from '@/libs/env/index'
import { $ } from '@/libs/jquery/index'

export class Analytics {
  public static sendGoalManually(category: string, action: string, label: string) {
    Analytics.send(category, action, label)
  }

  public static send(category: string, action: string, label: string) {
    if ((isProduction || isStaging) && typeof(ga) !== 'undefined') {

      ga('send', 'event', category, action, label)
      if (typeof yaCounter !== 'undefined') {
        yaCounter.reachGoal([category, action, label].join('_'))
      }
    } else {
      const message = `sendGoal: category = ${category}, action = ${action}, label = ${label}`
      // tslint:disable-next-line:no-console
      console.log(message)
    }
  }

  constructor() {
    $(document).on(
      'ajax:success',
      'form[data-module-analytics-label]',
      this.sendGoalFormElement,
    )
  }

  private sendGoalFormElement(event) {
    const $element = $(event.currentTarget)

    const category = $element.data('moduleAnalyticsCategory')
    const action = $element.data('moduleAnalyticsAction')
    const label = $element.data('moduleAnalyticsLabel')
    Analytics.send(category, action, label)
  }
}
